import { isWarningMaterial, isProhibitionMaterial, isMandatoryMaterial, isGHSMaterial, } from './';
export default (function () {
    return (isWarningMaterial() ||
        isProhibitionMaterial() ||
        isMandatoryMaterial() ||
        isGHSMaterial());
});
